import { useOutletContext } from 'react-router-dom';
import React, {useState, useLayoutEffect, useRef} from 'react';

async function getAccountData(uuid) {
    const response = await fetch('/api/get-friend-account-data-uuid', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
            friend_uuid: uuid,
        })
    });

    const data = await response.json();

    if (response.ok) {
        return data
    } else {
        return false;
    }
}

async function acceptRequest(uuid) {
    const response = await fetch('/api/accept-friend-request', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
            friend_uuid: uuid,
        })
    });

    const data = await response.json();

    if (response.ok) {
        return data
    } else {
        return false;
    }
}

async function denyRequest(uuid) {
    const response = await fetch('/api/deny-friend-request', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
            friend_uuid: uuid,
        })
    });

    const data = await response.json();

    if (response.ok) {
        return data
    } else {
        return false;
    }
}

function AccountFriendsPending() {
    const {userPendingFriends} = useOutletContext();
    const hasInitialized = useRef(false);
    const [userFriendsData, setUserFriendsData] = useState([])

    useLayoutEffect(() => {
        const getFriendsData = async () => {
            if (!hasInitialized.current && userPendingFriends) {
                await Promise.all(
                    userPendingFriends.map(async (uuid) => {
                        var data = await getAccountData(uuid)
                        data.nome = data.name + " " + data.surname
                        data.user_uuid = uuid;
                        setUserFriendsData([...userFriendsData, data])
                    })
                );
                hasInitialized.current = true;
            }
        };

        getFriendsData()
    }, [userPendingFriends, userFriendsData])

    const handleAccept = (user_uuid, id) => async () => {
        await acceptRequest(user_uuid);
        setUserFriendsData(prev => prev.filter(item => item.friendCode !== id));
    };

    const handleDecline = (user_uuid, id) => async () => {
        console.log(await denyRequest(user_uuid));
        setUserFriendsData(prev => prev.filter(item => item.friendCode !== id));
    };

    return (
        <div>
            <div className="flex items-center justify-between px-2 pb-4 pt-2">
                <h3 className="text-slate-900 dark:text-white text-lg font-bold leading-tight tracking-tight uppercase font-display">Received Requests ({userFriendsData.length})</h3>
            </div>

            <div className="grid gap-3">
                {userFriendsData.length === 0 ? (
                    <p className="text-slate-500 text-center py-8">Empty</p>
                ) : (
                    userFriendsData.map((userFriendsData) => (
                        <div 
                        key={userFriendsData.friendCode} 
                        className="flex flex-col md:flex-row items-start gap-[15px] justify-start md:gap-0 md:items-center md:justify-between bg-slate-50 dark:bg-surface-dark border border-slate-200 dark:border-border-dark rounded-xl hover:border-primary/50 transition-all group"
                        >
                        <div className="flex items-center gap-4">
                            <div className="relative">
                            <div 
                                className="size-12 rounded-lg bg-slate-200 dark:bg-border-dark bg-cover bg-center border border-slate-300 dark:border-slate-700" 
                            ></div>
                            {}
                            <div className={`absolute -bottom-1 -right-1 size-3 rounded-full border-2 border-white dark:border-surface-dark ${userFriendsData.status === 'online' ? 'bg-emerald-500' : 'bg-slate-400'}`}></div>
                            </div>
                            
                            <div className="flex flex-col">
                            <span className="text-slate-900 dark:text-white font-bold text-base font-display">
                                {userFriendsData.nome} 
                                <span className="text-xs font-normal text-slate-400 ml-1">#{userFriendsData.friendCode}</span>
                            </span>
                            </div>
                        </div>

                        <div className="flex items-center gap-2">
                            <button 
                            onClick={handleAccept(userFriendsData.user_uuid, userFriendsData.friendCode)}
                            className="h-9 px-4 bg-primary text-white text-xs font-bold rounded-lg hover:brightness-110 transition-all uppercase flex items-center gap-2"
                            >
                            <span className="material-symbols-outlined text-sm">check</span> Accept
                            </button>
                            <button 
                            onClick={handleDecline(userFriendsData.user_uuid, userFriendsData.friendCode)}
                            className="h-9 px-4 bg-slate-200 dark:bg-border-dark text-slate-600 dark:text-slate-300 text-xs font-bold rounded-lg hover:bg-red-500/20 hover:text-red-500 transition-all uppercase flex items-center gap-2"
                            >
                            <span className="material-symbols-outlined text-sm">close</span> Decline
                            </button>
                        </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default AccountFriendsPending;